<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import type { AgeRules } from '$saga/views/Tour/types';

    export let kind: 'adults' | 'children';
    export let minAgeAllowed: number | null;
    export let maxAgeAllowed: number | null;
    export let ageRules: AgeRules;
</script>

{#if kind === 'adults'}
    <span class="text-sm"
        >{trans('tour.aside_panel.pax_popover.adults.label')}
        <!-- 18ans et plus -->
        {#if (!minAgeAllowed || minAgeAllowed < 18) && !maxAgeAllowed}
            {trans(
                'tour.aside_panel.pax_popover.adults.no_min_age_and_no_max_age',
            )}
        {/if}
        <!-- de 18ans à X -->
        {#if (!minAgeAllowed || minAgeAllowed < 18) && maxAgeAllowed !== null && maxAgeAllowed >= 18}
            {trans(
                'tour.aside_panel.pax_popover.adults.no_min_age_and_max_age_under_xxx',
                {
                    '%age%': String(maxAgeAllowed),
                },
            )}
        {/if}
        <!--de X ans à Y ans -->
        {#if minAgeAllowed !== null && minAgeAllowed >= 18 && maxAgeAllowed !== null && maxAgeAllowed >= 18}
            {trans(
                'tour.aside_panel.pax_popover.adults.min_age_older_xxx_and_max_age_under_yyy',
                {
                    '%minAge%': String(minAgeAllowed),
                    '%maxAge%': String(maxAgeAllowed),
                },
            )}
        {/if}
    </span>
{:else}
    <span class="text-sm">
        {trans('tour.aside_panel.pax_popover.children.label')}
        {#if !minAgeAllowed && (!maxAgeAllowed || maxAgeAllowed >= 18)}
            {trans(
                'tour.aside_panel.pax_popover.children.no_min_age_and_no_max_age',
            )}
        {/if}
        {#if ageRules.min.isUnder18Allowed && (!maxAgeAllowed || maxAgeAllowed >= 18)}
            {trans(
                'tour.aside_panel.pax_popover.children.min_age_older_xxx_and_no_max_age',
                {
                    '%age%': String(minAgeAllowed),
                },
            )}
        {/if}
        {#if !minAgeAllowed && ageRules.max.isUnder18Allowed}
            {trans(
                'tour.aside_panel.pax_popover.children.no_min_age_and_max_age_under_xxx',
                {
                    '%age%': String(maxAgeAllowed),
                },
            )}
        {/if}
        {#if ageRules.min.isUnder18Allowed && ageRules.max.isUnder18Allowed}
            {trans(
                'tour.aside_panel.pax_popover.children.min_age_older_xxx_and_max_age_under_yyy',
                {
                    '%minAge%': String(minAgeAllowed),
                    '%maxAge%': String(maxAgeAllowed),
                },
            )}
        {/if}
    </span>
{/if}
